// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ozj2","colMin":"styles_colMin__326Or"};